module.exports = __webpack_public_path__ + "img/infoguidance_mov_04.f0d3d4fd.jpg";